var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v("Hold Pay Report")]),_c('v-card-subtitle',[_c('generate-report-button')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }